import { AuthenticationStore } from './../../../permission/services/authentication.store';
import { Component, Input, OnInit } from '@angular/core';
import { OnyxSummaryEvent } from '../../models/event.summary';
import { MenuStore } from '../../../menus/service/menu.store';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { PaymentStatusUtils } from '../../utils/payment-status-utils';
import { Page } from '../../../shared/models/page';
import { Constants } from 'app/shared/constants';
import { GroupPayConfigStore } from '../../service/grouppay-config.store';
import { PaymentStatus } from 'app/event/models/payment-status.enum';

@Component({
  selector: 'pioneer-event-list-financial-table',
  templateUrl: './event-list-financial.component.html',
  styleUrls: ['./event-list-financial.component.css']
})
export class EventListFinancialComponent implements OnInit {

  @Input()
  events: Page<OnyxSummaryEvent>;

  public searchText: string;

  public isOoivEnabled: boolean;

  isAgencyUser: boolean;

  constructor(private environment: EnvironmentConfiguration,
              private menuStore: MenuStore,
              private groupPayConfigStore: GroupPayConfigStore,
              private authenticationStore: AuthenticationStore) {
  }

  ngOnInit() {
    this.menuStore.setPageHeader('EVENTS.TITLE', false);
    this.searchText = '';

    this.groupPayConfigStore.isOoivEnabled(null, null, null)
      .subscribe(ooivEnabled => {
        this.isOoivEnabled = ooivEnabled;
      });

    this.isAgencyUser = this.authenticationStore.isAgencyUser();
  }

  get eventCount(): number {
    return this.events.totalElements;
  }

  get eventCountForTranslate(): Object {
    return {
      eventCount: this.eventCount
    };
  }

  getPaymentAmount(eventSummary: OnyxSummaryEvent): number {
    if (PaymentStatusUtils.isError(<any>eventSummary.payStatus)) {
      return 0;
    } else {
      return Number(eventSummary.paymentAmount);
    }
  }

  getTaxAmount(eventSummary: OnyxSummaryEvent): number {
    if (PaymentStatusUtils.isError(<any>eventSummary.payStatus)) {
      return 0;
    } else {
      return Number(eventSummary.taxAmount);
    }
  }

  getPrepaymentAmount(eventSummary: OnyxSummaryEvent): number {
    if (PaymentStatusUtils.isError(<any>eventSummary.prepayStatus)) {
      return 0;
    } else {
      return Number(eventSummary.prepaymentAmount);
    }
  }

  getTotalPaymentAmount(eventSummary: OnyxSummaryEvent): number {
    return this.getPrepaymentAmount(eventSummary) + this.getPaymentAmount(eventSummary) + this.getTaxAmount(eventSummary);
  }

  getEstimatedDue(eventSummary: OnyxSummaryEvent): number {
    let estimatedDue = Number(eventSummary.dueAmount);
    estimatedDue = Math.max(estimatedDue, 0);
    return estimatedDue;
  }

  getTotalPaymentAmountByStatus(eventSummary: OnyxSummaryEvent): number {
    if (PaymentStatusUtils.isNoTotalPaid(<any>eventSummary.payStatus)) {
      return this.getPrepaymentAmount(eventSummary);
    } else {
      return this.getTotalPaymentAmount(eventSummary);
    }
  }

  getEstimatedDueByStatus(eventSummary: OnyxSummaryEvent): number {
    if (PaymentStatusUtils.isNoEstimatedDue(<any>eventSummary.payStatus)) {
      return 0;
    } else {
      return this.getEstimatedDue(eventSummary);
    }
  }

  getEventNameLine1(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
    } else {
      return name;
    }
  }

  getEventNameLine2(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      const line2: string = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
      if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
        return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
      } else {
        return line2;
      }
    } else {
      return null;
    }
  }

  getPaymentStatus(status: PaymentStatus) {
    return PaymentStatusUtils.getAwePaymentStatus(status, this.authenticationStore.isAgencyUser());
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-financial-table/event-list-financial.component.ts